import { ExchangeInfoDatum, INS_CoinList_Res, TradeData } from '@/types/covestAPI/ins'
import { ConvetDotSize, getFloatDotSize } from '@/utils/formatter'
import { create } from 'zustand'

import { persist } from 'zustand/middleware'
import { setAlert } from '@/stores/feature/alert'
import { INS_CoinList } from '@/lib/api/innovation'
import { getSpotSymbol, getSpotType } from '@/hook/spot/common'
import { isInsView } from '@/lib/settings'

export interface tickInfoType {
  priceTick: number // 가격 틱사이즈
  coinTick: number // 수량
  minNotional: number // 주문시 최소금액
  BaseAssetPrecision: number // 토큰 단위 : COE
  QuoteAssetPrecision: number // 평가 단위 : USDT
  BaseCommissionPrecision: number // 토큰 커미션 단위 : COE
  QuoteCommissionPrecision: number // 마켓 커미션 단위 : USDT
  TickDotSize: number
  StepDotSize: number
}

interface InsExchangeInfoValues {
  loadTime: number
  exInsSymbol: string
  exchangeMap: Map<string, ExchangeInfoDatum>
  tickInfo: Map<string, tickInfoType>
  curTickInfo: tickInfoType | null // 현재 보고 있는 틱사이즈
  curOrderbookTickList: string[] | null
  CTRTradStatus: TradeData | null
}

interface InsExchangeAction {
  insInit: () => void
  setExInsSymbol: (symbol: string) => void
  setExchangeList: (res: INS_CoinList_Res) => void
  setTickInfo: (res: INS_CoinList_Res) => void
  setCurTickInfo: (symbol: string) => void
  getInsTickInfo: (symbol: string) => tickInfoType
  APIInsExchangeInfo: () => Promise<void>
}

type InsExchangeInfoType = InsExchangeInfoValues & InsExchangeAction

const localStoragetName = 'ins-exchange-info-storage'
const defaultInsSpotSymbol = 'COEUSDT'

const defaultSpotExchange: InsExchangeInfoValues = {
  loadTime: 0,
  exInsSymbol: getSpotType() !== 'binance' ? getSpotSymbol() : defaultInsSpotSymbol, // defaultInsSpotSymbol,
  exchangeMap: new Map<string, ExchangeInfoDatum>(),
  tickInfo: new Map<string, tickInfoType>(),
  curTickInfo: null,
  curOrderbookTickList: null,
  CTRTradStatus: null,
}

const setcurOrderbookTickList = (priceTickSize: string | undefined | null) => {
  const defaultOrderTickSize = ['0.00001', '0.0001', '0.001', '0.01']
  if (!priceTickSize) {
    return defaultOrderTickSize
  }

  const tickSizeArr: string[] = []

  // 부동소수점 때문에 이렇게 함 (math.pow 제거)
  // 각 tickSize 계산 후 소수점 위치 삽입
  const tickSize = Number(priceTickSize)
  for (let i = 0; i < 4; i++) {
    const adjustedSize = tickSize - i

    if (adjustedSize > 0) {
      // 소수점 자리 생성 (e.g., "0.00001" for adjustedSize = 5)
      tickSizeArr.push('0.' + '0'.repeat(adjustedSize - 1) + '1')
    } else {
      // 정수 형태 (e.g., "1", "10" for adjustedSize <= 0)
      tickSizeArr.push('1' + '0'.repeat(Math.abs(adjustedSize)))
    }
  }
  console.log('tickSizeArr', tickSizeArr)
  return tickSizeArr
}

// const findTickData = (symbol: string, args: Map<string, ExchangeInfoDatum>) => {
//   const newMap = new Map<string, tickInfoType>()
//   let curOrderbookTickList: string[] = []
//   let obj: tickInfoType = {
//     priceTick: 0, // 초기값 설정
//     coinTick: 0, // 초기값 설정
//     minNotional: 0, // 초기값 설정
//     BaseAssetPrecision: 0,
//     QuoteAssetPrecision: 0,
//   }

//   args.forEach((el) => {
//     const pricetick = el.PriceInfo.TickSize_str
//     const cointick = el.LotInfo.StepSize_str
//     const notional = el.NotionalInfo.MinNotional_str
//     newMap.set(el.Symbol, {
//       priceTick: getFloatDotSize(pricetick),
//       coinTick: getFloatDotSize(cointick),
//       minNotional: Number(notional),
//       BaseAssetPrecision: el.BaseAssetPrecision,
//       QuoteAssetPrecision: el.QuoteAssetPrecision,
//     })

//     if (symbol === el.Symbol) {
//       obj.priceTick = getFloatDotSize(pricetick)
//       obj.coinTick = getFloatDotSize(cointick)
//       obj.minNotional = Number(notional)
//       console.log('obj. : ', obj)
//       curOrderbookTickList = setcurOrderbookTickList(String(getFloatDotSize(pricetick)) || null)
//     }
//   })

//   return {
//     tickInfo: newMap,
//     curTickInfo: obj,
//     curOrderbookTickList,
//   }
// }

/*
const LoadInitInsState = (): InsExchangeInfoValues => {
  try {
    const storedData = localStorage.getItem(localStoragetName)
    if (!storedData) {
      return defaultSpotExchange
    }

    const parsedData = JSON.parse(storedData)
    let exchangeInfoMap: Map<string, ExchangeInfoDatum> = new Map()
    let argtickInfo: Map<string, tickInfoType>
    let argcurTickInfo: tickInfoType | null
    let argcurOrderbookTickList: string[] | null

    if (parsedData.state.exchangeMap) {
      const exchangeInfoMapArray = parsedData.state.exchangeMap

      if (Array.isArray(exchangeInfoMapArray)) {
        exchangeInfoMap = new Map(exchangeInfoMapArray.map((item) => [item.Symbol, item]))
        // 여기에 넣기
        const { tickInfo, curTickInfo, curOrderbookTickList } = findTickData(parsedData.state.exSpotSymbol, exchangeInfoMap)

        argtickInfo = tickInfo
        argcurTickInfo = curTickInfo
        argcurOrderbookTickList = curOrderbookTickList
      }
    }
    // console.log("exchangeInfoMap", exchangeInfoMap);
    const data = {
      loadTime: parsedData.state.loadTime || 0,
      exInsSymbol: parsedData.state.exInsSymbol || 'COEUSDT',
      exchangeMap: exchangeInfoMap, // Map이긴한데 실제로는 array오는 오류가 있음 개화남
      tickInfo: argtickInfo,
      curTickInfo: argcurTickInfo,
      curOrderbookTickList: argcurOrderbookTickList,
    }
    // console.log("data : ", data);
    return data
  } catch (e) {
    return defaultSpotExchange
  }
}
*/

export const storeInsExchangeInfo = create<InsExchangeInfoType>()(
  persist(
    (set, get) => ({
      // ...(LoadInitInsState() as InsExchangeInfoType),
      ...defaultSpotExchange,
      insInit: () => {
        // :TODO INS 관련 데이터 막기
        if (!isInsView()) return
        if (get() === undefined || get().exchangeMap === undefined || get().exchangeMap === null) {
          return
        }
        let exchangeMap = get().exchangeMap
        let tmp = new Map<string, ExchangeInfoDatum>()
        if (Array.isArray(exchangeMap)) {
          exchangeMap.forEach((el) => {
            tmp.set(el.Symbol, el)
          })
          set({ exchangeMap: tmp })
        }
        if (tmp.size === 0) {
          get().APIInsExchangeInfo()
          return
        }
        console.log('get().exchangeMap : ', tmp)
        const obj = tmp.get(defaultInsSpotSymbol)
        if (obj === undefined) {
          get().APIInsExchangeInfo()
          return
        }
        const dt = new Date().getTime()
        if (get().loadTime + 3600 * 1000 < dt) {
          get().APIInsExchangeInfo()
        }
      },
      setExInsSymbol: (symbol: string) => {
        // if (symbol === get().exInsSymbol) {
        //   return;
        // }
        try {
          set({ exInsSymbol: symbol })
          get().setCurTickInfo(symbol)
        } catch (e) {
          setAlert({
            title: 'not change Symbol on spot',
            message: e.message,
          })
        }
      },

      APIInsExchangeInfo: async () => {
        try {
          const res = await INS_CoinList('')
          get().setExchangeList(res)
          set({ loadTime: new Date().getTime() })
        } catch (e) {
          if (e === null || e === undefined) {
            return
          }

          setAlert({
            title: 'not APIInsExchangeInfo',
            message: e.message,
          })
        }
      },
      setExchangeList: (args: INS_CoinList_Res) => {
        const newMap = new Map<string, ExchangeInfoDatum>()
        args?.ExchangeInfoData?.forEach((el: ExchangeInfoDatum) => {
          newMap.set(el.Symbol, el)
        })

        if (args?.CTRTradStatus) {
          set({ CTRTradStatus: args.CTRTradStatus })
        }

        set({ exchangeMap: newMap })

        get().setTickInfo(args)
      },
      setTickInfo: (args: INS_CoinList_Res) => {
        const newMap = new Map<string, tickInfoType>()
        let argsOrderbookList: string[] = []
        let obj: tickInfoType = {
          priceTick: 0, // 초기값 설정
          coinTick: 0, // 초기값 설정
          minNotional: 0, // 초기값 설정
          BaseAssetPrecision: 0,
          QuoteAssetPrecision: 0,
          BaseCommissionPrecision: 0,
          QuoteCommissionPrecision: 0,
          TickDotSize: 0,
          StepDotSize: 0,
        }

        args?.ExchangeInfoData?.forEach((el: ExchangeInfoDatum) => {
          const pricetick = el.PriceInfo.TickSize_str
          const cointick = el.LotInfo.StepSize_str
          const notional = el.NotionalInfo.MinNotional_str
          newMap.set(el.Symbol, {
            priceTick: getFloatDotSize(pricetick),
            coinTick: getFloatDotSize(String(cointick)),
            minNotional: getFloatDotSize(notional),
            BaseAssetPrecision: el.BaseAssetPrecision,
            QuoteAssetPrecision: el.QuoteAssetPrecision,
            BaseCommissionPrecision: el.BaseCommissionPrecision,
            QuoteCommissionPrecision: el.QuoteCommissionPrecision,
            TickDotSize: el.PriceInfo.TickDotSize,
            StepDotSize: el.LotInfo.StepDotSize,
          })

          if (get().exInsSymbol === el.Symbol) {
            obj.priceTick = getFloatDotSize(pricetick)
            obj.coinTick = getFloatDotSize(cointick)
            obj.minNotional = parseFloat(notional)
            argsOrderbookList = setcurOrderbookTickList(String(getFloatDotSize(pricetick)) || null)
          }
        })
        set({
          tickInfo: newMap,
          curTickInfo: obj,
          curOrderbookTickList: argsOrderbookList,
        })
      },
      setCurTickInfo: (symbol: string) => {
        const obj = get().tickInfo?.get(symbol)
        if (obj === undefined) {
          console.error('ticker 안되네 ? ')
          return
        }

        const priceTick = obj?.priceTick ? String(obj?.priceTick) : null

        const orderbookTickList = setcurOrderbookTickList(priceTick)

        set({
          curTickInfo: obj,
          curOrderbookTickList: orderbookTickList,
        })
      },
      getInsTickInfo: (symbol: string): tickInfoType => {
        const tmp: tickInfoType = {
          priceTick: 2, // 가격 틱사이즈
          coinTick: 2, // 수량
          minNotional: 10, // 주문시 최소금액
          BaseAssetPrecision: 0,
          QuoteAssetPrecision: 0,
          BaseCommissionPrecision: 0,
          QuoteCommissionPrecision: 0,
          StepDotSize: 0,
          TickDotSize: 0,
        }

        const tick = get().tickInfo
        if (tick === null) {
          return tmp
        }

        const tickTmp = tick.get(symbol)
        if (tickTmp === undefined) {
          return tmp
        }
        return tickTmp
      },
    }),
    {
      name: localStoragetName,
      partialize: (state) => ({
        loadTime: state.loadTime,
        // exInsSymbol: state.exInsSymbol,
        // exchangeMap: state.exchangeMap ? Array.from(state.exchangeMap.values()) : [],
        // curOrderbookTickList: state.curOrderbookTickList,
      }),
    },
  ),
)

// Array를 Map으로 변환하는 함수
const arrayToMap = (array: Array<any>) => {
  return new Map(array)
}

export const INS_GetCoinTickSize = (coinID: string) => {
  //GetCoinTickSize 코인의 틱 사이즈 리턴 => 찾을수없을경우 null 리턴
  if (!coinID) return 2
  const { tickInfo } = storeInsExchangeInfo.getState()
  const id = coinID.toUpperCase()
  const obj = tickInfo.get(id)
  if (!obj) {
    return 2
  }
  return obj.coinTick
}
export const INS_GetCoinTickInfo = (coinID: string) => {
  //GetCoinTickSize 코인의 틱 사이즈 리턴 => 찾을수없을경우 null 리턴
  if (!coinID) return null
  const { tickInfo } = storeInsExchangeInfo.getState()
  const id = coinID.toUpperCase()
  const obj = tickInfo.get(id)
  if (!obj) {
    return null
  }
  return obj
}

//코인의 틱 사이즈 리턴 => 찾을수없을경우 null 리턴
export const INS_GetPriceTickSize = (coinID: string) => {
  if (!coinID) return null
  const coin = coinID?.toUpperCase()
  const obj = storeInsExchangeInfo.getState().tickInfo.get(coin)
  if (!obj) return 2

  return obj.priceTick
}

//해당 코인의 가격을 받아 틱사이즈 소숫점으로 변환 해서 리턴(문자열)
export const INS_ConvertPriceTodotSize = (coinID: string, price: number) => {
  const ticksize = INS_GetPriceTickSize(coinID.toUpperCase())
  return ConvetDotSize(String(price), ticksize)
}

//해당 코인의 수량을 받아 틱사이즈 소숫점으로 변환 해서 리턴(문자열)
export const INS_ConvertCoinTodotSize = (coinID: string, price: number) => {
  const ticksize = INS_GetCoinTickSize(coinID.toUpperCase())
  return ConvetDotSize(String(price), ticksize)
}

// 현재 거래 가능 코인 체크
export const INS_IsAssetInfo = (coinID: string): ExchangeInfoDatum | null => {
  const info = storeInsExchangeInfo.getState().exchangeMap.get(coinID.toUpperCase())

  if (info?.TradStatus === 'READY' || info?.TradStatus === 'TRADING') {
    return info
  } else {
    return null
  }
}

// 현재 코인이 트레이딩인지 확인
export const INS_IsAssetInfoBuyStart = (coinID: string) => {
  const info = storeInsExchangeInfo.getState().exchangeMap.get(coinID.toUpperCase())
  if (info?.TradStatus === 'BUY_START') {
    return true
  } else {
    return false
  }
}
